import VehicleEditionForm from './VehicleEditionForm';

export default VehicleEditionForm;
